const getEnv = (keyForDev, keyForProd) => {
  return process.env.BUILD_ENV === "production" ? keyForProd : keyForDev;
}

export default getEnv;